export default [{ value: "ادواری", label: "ادواری" }];
